import * as React from 'react';
import {percent, px} from '@packages/systems/core/utils/WebflowCssSubset';
import {Atom} from '@packages/systems/wfdl';
import {TListOfElement} from '@packages/systems/wfdl-ast';
import {createIntegratedAtom} from '@packages/utilities/integrated-types';
import {getChildren} from '@packages/utilities/data-utils';

const UserAccountSubscriptionListItemInfo = Atom.createRender(
  ({data, generateAttributes, attributes, classes, renderChild}) => (
    <div {...generateAttributes(attributes, classes)}>
      {getChildren(data).map((child) => renderChild(child))}
    </div>
  )
);

const config = createIntegratedAtom({
  displayName: 'Div Block',
  showEmpty: true,
  constraints: {
    ancestors: [{is: 'UserAccountSubscriptionListItem', rule: 'ExactlyOne'}],
  },
  style: {
    base: {
      main: {
        noPseudo: {
          display: 'flex',
          marginRight: px(16),
          marginLeft: px(16),
          flexDirection: 'column',
          flexGrow: 1,
          flexShrink: 1,
          flexBasis: percent(0),
        },
      },
    },
  },
  render: UserAccountSubscriptionListItemInfo,
  fields: {children: TListOfElement},
});

export default config;
